import React from "react";
import { Input } from "@chakra-ui/react";
import { FieldWrapper } from "../../components/form/FieldWrapper";
import { NullableSwitch } from "../../components/form/NullableSwitch";
import { useDisabled, useNAState, isNA, isEmptyValue } from "../../utils/formField";

const toInputDate = (v: string): string => {
  if (!v || isNA(v)) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
  const d = new Date(v);
  if (isNaN(+d)) return "";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const DateField: React.FC<any> = ({ field, value = "", readOnly, invalid, submitted = false }) => {
  const nullable = field?.nullable === true;
  const { mode, setMode, text, setText } = useNAState({ value, nullable });
  const { ro, disabled } = useDisabled({ readOnly, nullable, mode });
  const requiredNow = !nullable || mode === "val";
  const inputValue = toInputDate(text);
  const derivedInvalid = !!invalid || (submitted && requiredNow && isEmptyValue(inputValue));

  return (
    <FieldWrapper field={field} invalid={derivedInvalid}>
      <NullableSwitch nullable={nullable} mode={mode} setMode={setMode} readOnly={ro}>
        <Input
          name={!ro && requiredNow ? field.name : undefined}
          type="date"
          value={inputValue}
          onChange={(e) => setText(e.target.value || "")}
          isDisabled={disabled}
          readOnly={ro}
        />
      </NullableSwitch>

      {ro && <input type="hidden" name={field.name} value={nullable ? (mode === "na" ? "N/A" : inputValue) : inputValue} />}
      {!ro && nullable && mode === "na" && <input type="hidden" name={field.name} value="N/A" />}
    </FieldWrapper>
  );
};

export default DateField;
